// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.archivedAiTableWrapper__tDtw_ {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 320px);
  overflow: auto;
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.0509803922), 0px 0px 1px 0px rgba(12, 26, 75, 0.2392156863);
}
.archivedAiTableWrapper__tDtw_::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.archivedAiTableWrapper__tDtw_::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.archivedAiTableWrapper__tDtw_::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.archivedAiTableWrapper__tDtw_::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 1275px) {
  .archivedAiTableWrapper__tDtw_ {
    max-height: calc(100vh - 318px);
  }
}
@media (max-width: 850px) {
  .archivedAiTableWrapper__tDtw_ {
    max-height: calc(100vh - 278px);
  }
}

.archivedAiTable__TzzoM {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.archivedAiTable__TzzoM th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  text-align: left;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}
@media (max-width: 1275px) {
  .archivedAiTable__TzzoM th {
    padding: 16px 12px;
  }
}
@media (max-width: 1000px) {
  .archivedAiTable__TzzoM th {
    padding: 10px 12px;
  }
}
.archivedAiTable__TzzoM td {
  padding: 8px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  letter-spacing: 0.01em;
  font-size: 12px;
  line-height: 16px;
  vertical-align: middle;
}
@media (max-width: 1275px) {
  .archivedAiTable__TzzoM td {
    padding: 8px 12px;
  }
}

.archivedAiBodyRow__khS7A:hover {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-hover);
  cursor: pointer;
}

.archivedAiTableSortIcon__gfMsc {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.archivedAiTableSortIcon__gfMsc path {
  fill: var(--tables-title-icon);
}

.activeSort__K351M path {
  fill: var(--tables-primary-row-icon);
}

.ellipsisTextTwoLines__wQmQ3 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.ellipsisTextThreeLines__hRjfO {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.facilityName__qY53w {
  color: var(--tables-primary-row-text-additional);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.assetColumn__y1FWx {
  display: flex;
  align-items: center;
}

.alignRightColumn__tyyqp {
  text-align: right !important;
}

.lifetimeRange__C6s6G {
  color: var(--tables-primary-row-text-additional);
  white-space: nowrap;
}
@media (max-width: 1070px) {
  .lifetimeRange__C6s6G {
    white-space: wrap;
  }
}

.totalCostAvoidedColumn__jqIHU {
  text-align: right !important;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
@media (max-width: 1000px) {
  .totalCostAvoidedColumn__jqIHU {
    text-wrap: wrap !important;
  }
}

.commentsCircle__E0bYQ {
  width: 17px;
  height: 17px;
  background: var(--tables-title-icon);
  border-radius: 50%;
  font-size: 10px;
  font-weight: 500;
  color: var(--labels-filled-text);
  line-height: 17px;
  text-align: center;
}

.componentName__u1rpB {
  display: none;
  color: var(--tables-primary-row-text-additional);
}
@media (max-width: 1000px) {
  .componentName__u1rpB {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }
}

@media (max-width: 1000px) {
  .hideColumn__vsQDD {
    display: none;
  }
}

.showColumn__wab56 {
  display: none;
}
@media (max-width: 1000px) {
  .showColumn__wab56 {
    display: block;
  }
}

.skeletonRow__qxvTF td {
  padding-top: 15px;
  padding-bottom: 14px;
  padding-right: 0;
}

.skeletonText__J79q0 {
  height: 24px;
}

.skeletonCircle__VizDR {
  width: 17px;
  height: 17px;
  border-radius: 50%;
}

.rowLink__N4vww {
  display: contents;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Archive/components/ArchiveTable/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,qDAAA;EACA,2GACE;AA1EJ;AAmBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,+BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,8BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,kBAAA;AApBJ;AA8DE;EAZF;IAaI,+BAAA;EA3DF;AACF;AA6DE;EAhBF;IAiBI,+BAAA;EA1DF;AACF;;AA6DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AA1DF;AA4DE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA1DJ;AA4DI;EAhBF;IAiBI,kBAAA;EAzDJ;AACF;AA2DI;EApBF;IAqBI,kBAAA;EAxDJ;AACF;AA2DE;EACE,iBAAA;EACA,0CAAA;EACA,yDAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAzDJ;AA2DI;EATF;IAUI,iBAAA;EAxDJ;AACF;;AA6DE;EACE,yDAAA;EACA,mDAAA;EACA,eAAA;AA1DJ;;AA8DA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AA3DF;AA6DE;EACE,8BAAA;AA3DJ;;AAgEE;EACE,oCAAA;AA7DJ;;AAiEA;EArHE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAkHA,qBAAA;EACA,aAAA;AAzDF;;AA4DA;EA3HE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAwHA,qBAAA;EACA,aAAA;AApDF;;AAuDA;EACE,gDAAA;EAlIA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA+HA,qBAAA;EACA,aAAA;AA/CF;;AAkDA;EACE,aAAA;EACA,mBAAA;AA/CF;;AAkDA;EACE,4BAAA;AA/CF;;AAkDA;EACE,gDAAA;EACA,mBAAA;AA/CF;AAiDE;EAJF;IAKI,iBAAA;EA9CF;AACF;;AAiDA;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AA9CF;AAgDE;EANF;IAOI,0BAAA;EA7CF;AACF;;AAgDA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;AA7CF;;AAgDA;EACE,aAAA;EACA,gDAAA;AA7CF;AA+CE;EAJF;IAKI,cAAA;IAtLF,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,qBAAA;IACA,oBAAA;IACA,4BAAA;IAoLE,qBAAA;IACA,aAAA;EAxCF;AACF;;AA4CE;EADF;IAEI,aAAA;EAxCF;AACF;;AA2CA;EACE,aAAA;AAxCF;AA0CE;EAHF;IAII,cAAA;EAvCF;AACF;;AA2CE;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAxCJ;;AA4CA;EACE,YAAA;AAzCF;;AA4CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAzCF;;AA4CA;EACE,iBAAA;AAzCF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.archivedAiTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 320px);\n  overflow: auto;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow:\n    0px 3px 8px -1px #3232470d,\n    0px 0px 1px 0px #0c1a4b3d;\n\n  @include scrollBar;\n\n  @media (max-width: 1275px) {\n    max-height: calc(100vh - 318px);\n  }\n\n  @media (max-width: 850px) {\n    max-height: calc(100vh - 278px);\n  }\n}\n\n.archivedAiTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    text-align: left;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n\n    @media (max-width: 1275px) {\n      padding: 16px 12px;\n    }\n\n    @media (max-width: 1000px) {\n      padding: 10px 12px;\n    }\n  }\n\n  td {\n    padding: 8px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    letter-spacing: 0.01em;\n    font-size: 12px;\n    line-height: 16px;\n    vertical-align: middle;\n\n    @media (max-width: 1275px) {\n      padding: 8px 12px;\n    }\n  }\n}\n\n.archivedAiBodyRow {\n  &:hover {\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-hover);\n    cursor: pointer;\n  }\n}\n\n.archivedAiTableSortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.ellipsisTextTwoLines {\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n}\n\n.ellipsisTextThreeLines {\n  @include ellipsis-text;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n.facilityName {\n  color: var(--tables-primary-row-text-additional);\n  @include ellipsis-text;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.assetColumn {\n  display: flex;\n  align-items: center;\n}\n\n.alignRightColumn {\n  text-align: right !important;\n}\n\n.lifetimeRange {\n  color: var(--tables-primary-row-text-additional);\n  white-space: nowrap;\n\n  @media (max-width: 1070px) {\n    white-space: wrap;\n  }\n}\n\n.totalCostAvoidedColumn {\n  text-align: right !important;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  @media (max-width: 1000px) {\n    text-wrap: wrap !important;\n  }\n}\n\n.commentsCircle {\n  width: 17px;\n  height: 17px;\n  background: var(--tables-title-icon);\n  border-radius: 50%;\n  font-size: 10px;\n  font-weight: 500;\n  color: var(--labels-filled-text);\n  line-height: 17px;\n  text-align: center;\n}\n\n.componentName {\n  display: none;\n  color: var(--tables-primary-row-text-additional);\n\n  @media (max-width: 1000px) {\n    display: block;\n\n    @include ellipsis-text;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n  }\n}\n\n.hideColumn {\n  @media (max-width: 1000px) {\n    display: none;\n  }\n}\n\n.showColumn {\n  display: none;\n\n  @media (max-width: 1000px) {\n    display: block;\n  }\n}\n\n.skeletonRow {\n  td {\n    padding-top: 15px;\n    padding-bottom: 14px;\n    padding-right: 0;\n  }\n}\n\n.skeletonText {\n  height: 24px;\n}\n\n.skeletonCircle {\n  width: 17px;\n  height: 17px;\n  border-radius: 50%;\n}\n\n.rowLink {\n  display: contents;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"archivedAiTableWrapper": `archivedAiTableWrapper__tDtw_`,
	"archivedAiTable": `archivedAiTable__TzzoM`,
	"archivedAiBodyRow": `archivedAiBodyRow__khS7A`,
	"archivedAiTableSortIcon": `archivedAiTableSortIcon__gfMsc`,
	"activeSort": `activeSort__K351M`,
	"ellipsisTextTwoLines": `ellipsisTextTwoLines__wQmQ3`,
	"ellipsisTextThreeLines": `ellipsisTextThreeLines__hRjfO`,
	"facilityName": `facilityName__qY53w`,
	"assetColumn": `assetColumn__y1FWx`,
	"alignRightColumn": `alignRightColumn__tyyqp`,
	"lifetimeRange": `lifetimeRange__C6s6G`,
	"totalCostAvoidedColumn": `totalCostAvoidedColumn__jqIHU`,
	"commentsCircle": `commentsCircle__E0bYQ`,
	"componentName": `componentName__u1rpB`,
	"hideColumn": `hideColumn__vsQDD`,
	"showColumn": `showColumn__wab56`,
	"skeletonRow": `skeletonRow__qxvTF`,
	"skeletonText": `skeletonText__J79q0`,
	"skeletonCircle": `skeletonCircle__VizDR`,
	"rowLink": `rowLink__N4vww`
};
module.exports = ___CSS_LOADER_EXPORT___;
